import styled from 'styled-components'
import { widthResize, widthFull, heightHeader, boxShadow, navy, muted, surface, borderSoft } from '../Resources/Theme'

const Header = styled.header`
  height: ${heightHeader};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  margin-left: ${props => props.resize ? widthResize : widthFull};
  box-shadow: none;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid ${borderSoft};
  transition: width 0.28s ease, margin 0.28s ease;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  z-index: 4;
  margin-bottom: 0;
  position: sticky;
  top: 0;
  padding: 0 16px 0 8px;

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
    padding: 0 12px;
    grid-template-columns: 1fr auto 1fr;
  }
`

Header.Left = styled.div`
  height: ${heightHeader};
  display: flex;
  align-items: center;
  color: ${navy};
  gap: 8px;
  font-weight: 600;
  min-width: 0;
  flex: 1;

  @media (max-width: 992px) {
    width: auto;
  }
`

Header.Brand = styled.div`
  display: none;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    align-self: center;
    justify-content: center;
    display: flex;
  }
`

Header.Brand.Logo = styled.img`
  @media (max-width: 992px) {
    max-height: 36px;
    object-fit: contain;
  }
`

Header.Right = styled.div`
  height: ${heightHeader};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-height: ${heightHeader};
  gap: 4px;

  @media (max-width: 992px) {
    width: auto;
  }
`

Header.Right.Icon = styled.i`
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.05rem;
  color: ${muted};
  cursor: pointer;
  border-radius: 12px;
  transition: background 0.18s ease, color 0.18s ease;

  &:hover {
    background-color: #F3F4F6;
    color: ${navy};
  }

  @media (max-width: 992px) {
    width: 36px;
    height: 36px;
  }
`

Header.Right.Image = styled.img`
  border-radius: ${props => props.maxHeight ? props.maxHeight : '30px'};
  max-height: ${props => props.maxHeight ? props.maxHeight : '34px'};
  box-shadow: ${boxShadow};
  object-fit: cover;
`

export default Header
